import { RecurringAssignmentsModal } from '~/app/pages/SurgeonScheduler/StaffingPlanAutofill/RecurringAssignments/RecurringAssignmentsModal'
import { PractitionerPopover } from '~/app/pages/SurgeonScheduler/TablesLayout/Practitioners/Table/PractitionerRow/PractitionerPopover'

import { useDialogRouter } from './useDialogRouter'

export const DialogRouter = () => {
    const { activeDialog, dialogData, closeDialog } = useDialogRouter()

    if (!activeDialog) {
        return null
    }

    switch (activeDialog) {
        case 'practitioner':
            return <PractitionerPopover {...dialogData} onClose={closeDialog} />

        case 'recurringAssignments':
            return <RecurringAssignmentsModal onClose={closeDialog} />

        default:
            activeDialog satisfies never
    }
}
